import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
import styles from "../NotificationFilterDrawer.module.scss";
export const SearchContainer = ({ children, title, customClassName }) => {
    return (_jsx("div", { className: styles['search-container'], children: _jsxs("div", { className: `${customClassName || 'mx-4 py-4'}`, children: [_jsx(CatHeading, { variant: "label", children: title }), children] }) }));
};
